<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Kullanıcı Oluştur</h4>
              <p class="card-category">Paneli kullanacak olan kullanıcıyı oluşturun.</p>



              <form class="m-5">
                <div class="row">
                  <div class="col-md-6">
                    <base-input type="text" label="İsim" placeholder="İsim" v-model="payload.name">
                    </base-input>
                  </div>
                  <div class="col-md-6">
                    <base-input type="text" label="Soyisim" placeholder="Soyisim" v-model="payload.surname">
                    </base-input>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <base-input type="text" label="E-Posta" placeholder="E-Posta" v-model="payload.email">
                    </base-input>
                  </div>

                  <div class="col-md-6">
                    <base-input type="text" label="Şifre" placeholder="Şifre" v-model="payload.password">
                    </base-input>
                  </div>
                </div>

                <div class="row">

                  <div class="col-md-6">
                    <label>Rol Seçimi</label>

                    <select class="form-control" v-model="payload.role">
                      <option value="-1">Rol Seçiniz</option>
                      <option v-for="role in roleMap" :key="role._id" :value="role._id">
                        {{ role.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-6" v-if="payload.role == 'DEALER_PARTNER'">
                    <label>Bayii Seçimi</label>
                    <div v-for="dealer in payload.dealers" :key="dealer" class="mb-3">

                      <select class="form-control" v-model="dealer.dealerId">
                        <option value="-1">Bayii Seçiniz</option>
                        <option v-for="dealer in dealers" :key="dealer._id" :value="dealer._id">
                          {{ dealer.title }} ({{ dealer.code }})
                        </option>
                      </select>

                    </div>
                    <div>
                      <button type="submit" class="btn btn-secondary btn-fill float-right btn-sm pt mt-4"
                        @click="addNewDealer()">
                        Başka Bayii Ekle
                      </button>
                    </div>
                  </div>

                </div>


                <div class="row pt-5">
                  <div class="col-md-12">
                    <label>Aktif Mi?</label>
                    <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="payload.isActive"
                      :checked="payload.isActive" @click="payload.isActive = !payload.isActive">
                    </base-checkbox>
                  </div>
                </div>






                <div class="text-center pt-5">
                  <button type="submit" class="btn btn-info btn-fill float-right" @click="createNewUser()">
                    Oluştur
                  </button>
                </div>
                <div class="clearfix"></div>
              </form>

            </template>
          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      payload: {
        name: "",
        surname: "",
        email: "",
        password: "",
        role: "-1",
        dealers: [{
          dealerId: "-1",
        }],
        isActive: true
      },
      roleMap: [
        {
          _id: "MODERATOR",
          name: "Moderator"
        },
        {
          _id: "DEALER_PARTNER",
          name: "Bayii Sahibi"
        },
        {
          _id: "ADMIN",
          name: "Admin"
        }
      ],
      dealers: []
    }
  },
  mounted() {
    this.getDealers();
  },
  methods: {
    createNewUser() {
      CollectionService.postWidthAuth('users', this.payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Kullanıcı Oluşturuldu")
          this.$router.push(`/admin/users`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err.response.data.body)
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notify({
        message: JSON.stringify(message),
        icon: '',
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type
      })
    },
    getDealers() {

      let q = {};
      let p = {};
      let o = { skip: 0, limit: 1000, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('dealer', query).then((res) => {
        this.dealers = res.dealers;
      })
    },
    addNewDealer() {
      this.payload.dealers.push({
        dealerId: "-1",
      });
    }
  }
}
</script>
<style></style>
